/* agmf-buy-tail.js — an Add to cart button that is ALWAYS the last thing in
 * the buy column.
 *
 * Dorian 2026-09-08: "I want to add a button always at the very end of the
 * second column, the column where there is all the accordion, etc (under
 * it) ... an add to cart button ... and track the clicks on it as a new
 * kind of add to cart (differentiate from any other)".
 *
 * WHAT IT IS. The bridge supplies the complete buy column: `.product-info`
 * on a standard PDP, or the outer `.agb-main` on Gear Builder (where the
 * product-info, suggestions and accordions are siblings). This puts one more
 * Add to cart after all of that, and keeps it there: if anything is appended
 * behind it, it moves back to the end.
 *
 * HOW IT ADDS. It asks agmf-product-bridge.js to click the active page button.
 * On a normal PDP that is the product form; on Gear Builder it is the visible
 * add-all control. EasySuggestions, the chosen variant/loadout, quantity,
 * gates and every other system therefore run exactly as they do on the page.
 * The label and disabled state are mirrored from that real button.
 *
 * HOW IT IS COUNTED. agmf-track.js names a press on [data-agmf-buy-tail-atc]
 * `atc_column_end` and records the add as control `column_end` — its own kind,
 * apart from the form's button and the sticky bar's. The click it forwards to
 * the form's button is synthetic (isTrusted false) and the tracker refuses
 * those, so one press is one event.
 *
 * Isolation: reads the DOM, edits nothing upstream, its own file and style.
 */
(function () {
  'use strict';
  if (window.__agmfBuyTail) return;
  window.__agmfBuyTail = true;

  function product() { return window.AGMF_PRODUCT_BRIDGE || null; }
  function column() { var p = product(); return p && p.getBuyColumn(); }
  function source() { var p = product(); return p && p.getAddToCartButton(); }

  var wrap = null, btn = null, watchedColumn = null, columnObserver = null;

  function style() {
    if (document.getElementById('agmf-buy-tail-style')) return;
    var s = document.createElement('style');
    s.id = 'agmf-buy-tail-style';
    s.textContent =
      '.agmf-buy-tail{margin:26px 0 12px}' +
      '.agmf-buy-tail [data-agmf-buy-tail-atc]{width:100%}';
    document.head.appendChild(s);
  }

  // the label and the disabled state follow the form's own button
  function mirror(src) {
    if (!btn || !src) return;
    var label = (src.textContent || '').replace(/\s+/g, ' ').trim() || 'Add to cart';
    if (btn.textContent !== label) btn.textContent = label;
    var off = !!src.disabled || src.getAttribute('aria-disabled') === 'true';
    btn.disabled = off;
    btn.setAttribute('aria-disabled', String(off));
    // Copy presentation, never integration hooks. `js-add-all` would make
    // Gear Builder/EasySuggestions treat this delegate as another primary.
    var cls = String(src.className || '')
      .replace(/\b(?:product-form__submit|js-add-all)\b/g, '')
      .replace(/\s+/g, ' ')
      .trim();
    if (cls && btn.className !== cls) btn.className = cls;
  }

  function watchColumn(col) {
    if (watchedColumn === col) return;
    if (columnObserver) columnObserver.disconnect();
    watchedColumn = col;
    columnObserver = null;
    if (col) {
      columnObserver = new MutationObserver(schedule);
      columnObserver.observe(col, { childList: true });
    }
  }

  function place() {
    var col = column(), src = source();
    watchColumn(col);
    if (!col || !src) {
      if (wrap) wrap.hidden = true;
      return;
    }
    if (!wrap) {
      style();
      wrap = document.createElement('div');
      wrap.className = 'agmf-buy-tail';
      btn = document.createElement('button');
      btn.type = 'button';
      btn.setAttribute('data-agmf-buy-tail-atc', '');
      btn.addEventListener('click', function () {
        var p = product();
        if (p) p.addToCart();
      });
      wrap.appendChild(btn);
    }
    wrap.hidden = false;
    mirror(src);
    // ALWAYS LAST: anything the page appends to the column after this moves it
    // back behind them - with ONE exception: the Ask card's anchor sits under
    // this button (Dorian 2026-09-14: "put it under the most bottom add to
    // cart"), so the button keeps the last place BEFORE that anchor.
    // ...and the desktop "Go back to top" (agdesk-back-to-top.js, Dorian
    // 2026-10-07) is the column's very last thing, so with no Ask anchor the
    // button keeps the last place before IT. Two scripts each insisting on
    // the last place would swap for ever; this one yields to that one.
    var ask = col.querySelector(':scope > .agmf-ask-mount') ||
              col.querySelector(':scope > .agdesk-totop');
    if (ask) {
      if (wrap.parentElement !== col || wrap.nextElementSibling !== ask) col.insertBefore(wrap, ask);
    } else if (col.lastElementChild !== wrap) {
      col.appendChild(wrap);
    }
  }

  var pending = 0;
  function schedule() {
    if (pending) return;
    pending = setTimeout(function () { pending = 0; place(); }, 50);
  }

  function boot() {
    var p = product();
    if (!p) return;
    place();
    // The bridge owns product-shell arrival, button replacement, label/state
    // changes and responsive swaps. This script owns only its placement.
    p.subscribe(schedule);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
